import type {
    FC
} from "react";
import {
    View
} from "react-native";
import type IAspectRatioStateProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Button from "../../../button";
import Icon from "../../../icon";
import Text from "../../../text";

const AspectRatioState: FC<IAspectRatioStateProps> = ({
    customLocalize,
    customTheme,
    description,
    isIconOnly,
    isAction,
    onRetry,
    title,
    icon
}) => {
    const {
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        stateText: stateTextDynamicStyle,
        state: stateDynamicStyle
    } = useStyles({
        isIconOnly,
        spaces
    });

    return <View
        aria-label={isIconOnly ? [
            title,
            description
        ].filter(Boolean).join(": ") : undefined}
        role={isIconOnly ? "img" : undefined}
        style={[
            stylesheet.state,
            stateDynamicStyle
        ]}
    >
        <Icon
            size={isIconOnly ? iconSizes.large : iconSizes.large * 2}
            customTheme={customTheme}
            color="low"
            icon={icon}
        />
        {
            isIconOnly ?
                null
            :
                <View
                    style={[
                        stylesheet.stateText,
                        stateTextDynamicStyle
                    ]}
                >
                    <Text
                        style={stylesheet.stateLine}
                        variant="labelMediumSize"
                        customTheme={customTheme}
                        color="high"
                    >
                        {title}
                    </Text>
                    {
                        description ?
                            <Text
                                style={stylesheet.stateLine}
                                customTheme={customTheme}
                                variant="bodySmallSize"
                                numberOfLines={2}
                                color="mid"
                            >
                                {description}
                            </Text>
                        :
                            null
                    }
                </View>
        }
        {
            isAction && !isIconOnly ?
                <Button
                    title={localize("try-again")}
                    customTheme={customTheme}
                    spreadBehaviour="free"
                    onPress={onRetry}
                    variant="outline"
                    type="neutral"
                    size="small"
                />
            :
                null
        }
    </View>;
};
export default AspectRatioState;
